import { Check } from 'lucide-react';

export function ImportStepIndicator({ currentStep }) {
  return (
    <div className="flex items-center justify-center mb-6">
      {[1, 2, 3, 4].map((step, index) => (
        <div key={step} className="flex items-center">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
            ${currentStep >= step
              ? 'bg-primary text-white'
              : 'bg-gray-200 text-gray-500'
            }`}
          >
            {currentStep > step ? <Check className="w-4 h-4" /> : step}
          </div>
          {index < 3 && (
            <div className={`w-12 h-1 mx-1 ${currentStep > step ? 'bg-primary' : 'bg-gray-200'}`} />
          )}
        </div>
      ))}
    </div>
  );
}
